module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_11.57bac3aa8851b3f05d7b00236a2c4e8d.png";